export default __webpack_public_path__ + "images/2P.820c380.png";